export const ROUTES = {
  CANCELLATION: '/cancellation',
  CANCELLED: '/cancelled',
  COMPLETE: '/complete',
  DAMAGE_REPORT: '/damage-report',
  END: '/end',
  FINISHED: '/finished',
  HOME: '/',
  INSPECTION: '/inspection',
  OTP_CODE: '/code',
  OUTCOME: '/outcome',
  PENDING: '/pending',
  PRICE_ADJUSTMENT: '/price-adjustment',
  PROFILE: '/profile',
  SEND_REPORT: '/send-report',
};
